export default __webpack_public_path__ + "static/media/arrow_back_white.02ad6345.svg";